import { Field } from 'formik';
import { DatePicker as RsuiteDatePicker } from 'rsuite';
// import '../../../../node_modules/';
import '../../../../../node_modules/rsuite/dist/rsuite.min.css';

export const DatePicker = ({
  name,
  title,
  disabledDate,
  placement,
  placeholder,
}) => {
  return (
    <Field name={name}>
      {({ meta, form: { values, setFieldValue } }) => (
        <div className="w-full">
          <p className="modal__form-el-label mb-2">{title}</p>
          <RsuiteDatePicker
            name={name}
            onChange={(date) => {
              setFieldValue(name, date);
            }}
            onChangeCalendarDate={(date) => {
              setFieldValue(name, date);
            }}
            value={values[name] || null}
            placement={placement}
            placeholder={placeholder}
            format={'MM-dd-yyyy'}
            role="presentation"
            oneTap
            className={`custom-date-picker w-full h-[48px] rounded-[5px] text-[#92928F] flex items-center justify-between ${meta.touched && meta.error ? 'has-error' : ''}`}
            disabledDate={disabledDate}
          />
        </div>
      )}
    </Field>
  );
};
